import NCM from './ncm'
import UF from './uf'
import Lei from './lei'
import CST from './cst'

export default class ICMS {
  constructor(id, descricao, icmsOriginal, icmsSaida, mva, observacao) {
    this.id = id
    this.descricao = descricao
    this.icmsOriginal = icmsOriginal
    this.icmsSaida = icmsSaida
    this.mva = mva
    this.observacao = observacao
    this.uf = new UF()
    this.ncm = new NCM()
    this.lei = new Lei()
    this.cst = new CST()
  }
}
